import {appConfig, i18n} from 'src/shared/config'

import fallbackSrc from './assets/bg.svg'
import type {Props} from './types'

export function useBusinessBannerModal(props: Props) {
  const {
    description = i18n(
      'banner.description.default',
      'Несколько минут на регистрацию — и у вас будет эта и другие возможности Доставки для бизнеса:',
    ),
    list = i18n(
      'banner.list.default',
      'оплата с расчётного счёта\nдоставка негабаритных вещей\nспециальные функции и тарифы.',
    ),
    imageSrc = fallbackSrc,
  } = props

  const queryParams: Record<string, string> = {offer: 'true'}
  if (props.utmSource) {
    queryParams.utm_source = props.utmSource
  }

  return {
    opened: props.opened,
    onClose: props.onClose,
    title: props.title,
    description,
    list: list.split('\n').filter(Boolean),
    imageSrc,
    link: appConfig.getRegistrationUrl(queryParams),
  } as const
}
